import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  change as changeFieldValue,
  Field,
  formValueSelector,
  reduxForm,
} from "redux-form";

import { FormattedMessage, intlShape } from "react-intl";
import * as dataActions from "../../../../../../../../utils/data/dataActions";
import { MessageBox, Render } from "../../../../../../../common";
import {
  CheckboxInput,
  DayPicker,
  NewSelectInput,
  SelectInput,
} from "../../../../../../../common/form";

import validationUtils from "../../../../../../../../utils/ValidationUtils";
import { DEPENDENT_COVERAGE_VALIDATION_RULES } from "./dependentCoverageValidationRules";
import { dependentCoverageStatuses } from "./enums/";

import moment from "moment";
import { BILLING_PERIODS } from "../../../../../../../../utils/data/models";
import { HR_CLERK, PLAN_ADMINISTRATOR } from "../../../../../../../../utils/Roles";
import { isDependentCoverageSynchronized } from "../../../../../../../common/synchronization/SynchronizationHelper";
import { RECURRING } from "../../../../../enums/billingPeriodTypes";

class BasicDependentCoverageFields extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      hasSuccess: false,
      currentUserRoleId: localStorage.getItem("roleId") || "",
      filteredBillingPeriods: [],
      showMessage: false
    };

    this.defineEndDate = this.defineEndDate.bind(this);
    this.onBillingPeriodChange = this.onBillingPeriodChange.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.filterBillingPeriods = this.filterBillingPeriods.bind(this);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  componentWillMount() {
    const {
      clientId,
      clientBillingPeriodType,
    } = this.props;

    if (clientBillingPeriodType === "MANUAL") {
      const fields = "billingPeriodId,endDate,startDate,localizations";
      let filters = [`billingPeriods.clientId==${clientId}`];
      this.props.dataActions.getDataList(
        BILLING_PERIODS,
        0,
        0,
        "",
        ["startDate:desc"],
        filters,
        null,
        {},
        fields
      ).then(() => {
        this.filterBillingPeriods();
      });
    }
    const isPlanAdministratorOrHRClerk = [
      PLAN_ADMINISTRATOR.roleId.toString(),
      HR_CLERK.roleId.toString(),
    ].includes(this.state.currentUserRoleId);
    if (isPlanAdministratorOrHRClerk && this.props.dependentPersonCoverageId) {
      isDependentCoverageSynchronized(this.props.dependentPersonCoverageId, this.props.dataActions, (res) => {
        const hasSuccess = res && res.payload && res.payload.data && res.payload.data["isSynchronized"];
        this.setState({ hasSuccess });
      });
    }
  }
  componentWillUnmount() {
    this.props.onStartDateChange(false, this.state.hasSuccess);
  }

  filterBillingPeriods() {
    const billingPeriods = this.props.billingPeriods;
    const currentId = this.props.initialValues.billingPeriodId;
    if (!billingPeriods || !billingPeriods.length) {
      this.setState({ filteredBillingPeriods: [] });
      return;
    }

    // Precompute dates and sort
    const periods = billingPeriods
      .map(p => ({ ...p, start: new Date(p.startDate), end: p.endDate ? new Date(p.endDate) : null }))
      .sort((a, b) => a.start - b.start);

    const dependentIds = new Set((this.props.allDependentCoverages || []).map(c => c.billingPeriodId));

    // Find current period
    let current = currentId ? periods.find(p => p.billingPeriodId === currentId) : null;
    let lowerLimit = current ? null : (this.props.latestCoverage
      ? periods.find(p => p.billingPeriodId === this.props.latestCoverage.billingPeriodId)
      : null);

    if (!current && !lowerLimit) {
      this.setState({ filteredBillingPeriods: periods });
      return;
    }

    // Find previous and next dependent periods relative to current
    let previousDependent = null;
    let nextDependent = null;

    if (current) {
      for (let p of periods) {
        if (!dependentIds.has(p.billingPeriodId)) continue;
        if (p.start < current.start) previousDependent = p;
        if (p.start > current.start && !nextDependent) nextDependent = p;
      }
    }
    const filtered = [];

    if (current) filtered.push(current);

    for (let p of periods) {
      if (current && p.billingPeriodId === current.billingPeriodId) continue;

      const afterPrev = previousDependent
        ? p.start > previousDependent.start
        : lowerLimit
          ? p.start > lowerLimit.start
          : true;

      const beforeNext = nextDependent ? p.start < nextDependent.start : true;

      if (afterPrev && beforeNext) filtered.push(p);
    }
    filtered.sort((a, b) => b.start - a.start);

    this.setState({ filteredBillingPeriods: filtered, showMessage: true });
  }


  defineEndDate(event) {
    const checked = event.target.checked;

    if (!checked) {
      this.props.changeFieldValue("dependentCoverage", "endDate", null);
    }
  }

  onBillingPeriodChange(e) {
    const billingPeriodId = e.target.value;
    if (billingPeriodId != " ") {
      const billingPeriod = this.props.billingPeriods.find(
        (period) => period.billingPeriodId == billingPeriodId
      );
      this.props.changeFieldValue(
        "dependentCoverage",
        "startDate",
        billingPeriod.startDate
      );
      this.props.changeFieldValue(
        "dependentCoverage",
        "endDate",
        billingPeriod.endDate
      );
    } else {
      this.props.changeFieldValue("dependentCoverage", "startDate", null);
      this.props.changeFieldValue("dependentCoverage", "endDate", null);
    }
  }
  onStartDateChange(event) {
    this.props.onStartDateChange(false, this.state.hasSuccess);
    const selectedDate = moment(event._d).format('YYYY-MM-DD');
    const startDate = this.props.initialValues.startDate ? moment(this.props.initialValues.startDate._d).format('YYYY-MM-DD') : null;
    if (startDate && selectedDate != startDate) {
      this.props.onStartDateChange(true, this.state.hasSuccess);
    }
  }

  render() {
    const { startDateLimit, endDateLimit } = this.props.initialValues;
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset disabled={this.props.disabled}>
          <Render if={this.props.clientBillingPeriodType === "MANUAL"}>
            <Field
              id="billingPeriodId"
              name="billingPeriodId"
              component={SelectInput}
              props={{ onChange: this.onBillingPeriodChange }}
              label={
                <FormattedMessage id="dependentCoverages.form.billingPeriod" />
              }
              addBlankOption={true}
              sortOptions={false}
              options={this.state.filteredBillingPeriods.map((period) => {
                return {
                  value: period.billingPeriodId,
                  text: period.localizations[this.props.authLanguageCode].name,
                };
              })}
              disabled={this.props.disabled}
            />
            {
              (!this.state.filteredBillingPeriods || this.state.filteredBillingPeriods.length === 0) &&
              this.state.showMessage && (
                <MessageBox key="noBillingPeriod" className="alert-warning">
                  <FormattedMessage id="dependentCoverages.form.noBillingPeriod" />
                </MessageBox>
              )
            }
          </Render>
          <Render if={this.props.clientBillingPeriodType != "MANUAL"}>
            <Field
              id="startDate"
              name="startDate"
              component={DayPicker}
              showClearButton={true}
              minDate={startDateLimit ? startDateLimit.clone().add(1, 'day') : startDateLimit}
              label={
                <FormattedMessage id="dependentCoverages.form.startDate" />
              }
              onChange={this.onStartDateChange}
            />
          </Render>

          <Render
            if={
              this.props.clientBillingPeriodType == "RECURRING" &&
              !this.props.disabled
            }
          >
            <Field
              props={{ onChange: this.defineEndDate }}
              id="defineEndDate"
              name="defineEndDate"
              component={CheckboxInput}
              checkbox={{ value: true }}
              disabled={this.props.initialValues.endDate && endDateLimit}
              label={
                <FormattedMessage id="memberCoverages.form.defineEndDate" />
              }
            />
          </Render>
          <Render
            if={
              this.props.clientBillingPeriodType == "RECURRING" &&
              this.props.defineEndDate
            }
          >
            <Field
              id="endDate"
              name="endDate"
              component={DayPicker}
              showClearButton={true}
              minDate={startDateLimit ? startDateLimit.clone().add(1, 'day') : startDateLimit}
              maxDate={endDateLimit}
              label={<FormattedMessage id="dependentCoverages.form.endDate" />}
            />
          </Render>

          <Field
            id="isInactive"
            name="isInactive"
            component={NewSelectInput}
            options={dependentCoverageStatuses}
            addBlankOption={true}
            label={<FormattedMessage id="dependentCoverages.form.status" />}
            disabled={this.props.disabled}
          />
          <Render
            if={
              this.props.clientBillingPeriodType == RECURRING.value
            }
          > <Field
              id="isStudent"
              name="isStudent"
              component={CheckboxInput}
              checkbox={{ value: true }}
              label={
                <FormattedMessage id="dependents.form.isStudent" />
              }
              disabled={this.props.disabled}
              normalize={(value) => !!value}
            />
          </Render>
        </fieldset>
      </form>
    );
  }
}

BasicDependentCoverageFields.propTypes = {
  billingPeriods: PropTypes.array,
  changeFieldValue: PropTypes.func,
  classId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classesList: PropTypes.array,
  clientBillingPeriodType: PropTypes.string,
  clientId: PropTypes.number,
  dataActions: PropTypes.object,
  defineEndDate: PropTypes.bool,
  disabled: PropTypes.bool,
  divisionsList: PropTypes.array,
  allDependentCoverages: PropTypes.array,
  handleSubmit: PropTypes.func,
  inactivityReason: PropTypes.string,
  initialValues: PropTypes.object,
  isInactive: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  latestCoverage: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  onStartDateChange: PropTypes.func,
  authLanguageCode: PropTypes.string,
  dependentPersonCoverageId: PropTypes.number
};

BasicDependentCoverageFields.defaultProps = {
  disabled: false,
  scene: "",
};

BasicDependentCoverageFields.contextTypes = {
  intl: intlShape,
};

BasicDependentCoverageFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  const billingPeriods = state.data.billingPeriods || {};

  const selector = formValueSelector("dependentCoverage");

  return {
    billingPeriods: billingPeriods.items || [],
    classId: selector(state, "classId"),
    defineEndDate: selector(state, "defineEndDate"),
    isInactive: selector(state, "isInactive"),
    inactivityReason: selector(state, "isInactiveReasonType"),
    authLanguageCode: state.auth.user.languageCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "dependentCoverage",
    validate: (values) =>
      validationUtils.validate(values, DEPENDENT_COVERAGE_VALIDATION_RULES),
  })(BasicDependentCoverageFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/coverages/BasicDependentCoverageFields.js